export const CUSTOM_ENUM_NONE = 'NONE'
